module.exports = __webpack_public_path__ + "img/top_icon02.cd0a7e4.png";